import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { AudioTrack } from '../../../asset/utils/AudioTrack';
import { AudioList } from '../../_molecules/AudioList';
import { ImageButton } from '../../_molecules/ImageButton';

const UnitWrap =styled.div`
  grid-row: span 3;
  position: relative;
  width: 100%;
  height: 100%;
  box-shadow: -5px 0 10px 0 #000;
`;

export const AudioListWrap = (props) => {
  const state = useSelector((state) => state);

  return (
    <>
      {props.page && (
        <>
          <ImageButton
            type="home"
            src="https://content.chungchy.com/PhonicsHero/web_resource/images/common/btn_home_150px.png"
            alt="HOME"
            onClick={() => window.location.hash="#/"}
          />
          <ImageButton
            type="back"
            src="https://content.chungchy.com/PhonicsHero/web_resource/images/common/btn_pre_150px.png"
            alt="BACK"
            onClick={() => window.location.hash="#/menu/" + (state.book.current_book + 1)}
          />
        </>
      )}
      <UnitWrap>
        <AudioList type="unit" list={AudioTrack[state.book.current_book]} page={props.page}/>
        <AudioList type="track" list={AudioTrack[state.book.current_book][state.track.unit_act]} page={props.page}/>
      </UnitWrap>
    </>
  );
};